import { CalendarScheduleDatasource } from "./calendar-schedule-datasource";
import { CalendarDatasource } from "./calendar-datasource";
import { CalendarMenuDatasource } from "./calendar-menu-datasource";
import { Utility } from "../libs/utility";
import * as moment from 'moment';

export class CalendarWidget {

	private static menuCalendar:CalendarWidget;
	private static scheduleCalendar: CalendarWidget;
	private static calendarSync = true;
	private lastPlayType = "Zum letzten Mal";

	public static initFromSchedule(rootElementId: string, targetId: string,locations:string[]) {
		const dataSource = new CalendarScheduleDatasource(rootElementId,locations);
		CalendarWidget.scheduleCalendar = new CalendarWidget(dataSource, targetId);
	}

	public static showInMenu(targetId: string) {
		if(CalendarWidget.menuCalendar) {
			return;
		}

		const dataSource = new CalendarMenuDatasource();
		CalendarWidget.menuCalendar = new CalendarWidget(dataSource, targetId, true);
	}

	public static syncMonth(year: number, month: number) {
		if(CalendarWidget.scheduleCalendar == null || CalendarWidget.calendarSync == false) {
			return;
		}

		CalendarWidget.scheduleCalendar.syncMonthInternal(year, month - 1);
	}

	public syncMonthInternal(year: number, month: number) {
		if(this.currentMonth.getUTCFullYear() != year || this.currentMonth.getUTCMonth() != month) {
			this.updateDisplay(new Date(Date.UTC(year, month, 1)));
		}
	}

	public static setSyncState(enabled: boolean) {
		this.calendarSync = enabled;
	}

	private target: Element;
	private previous: Element;
	private next: Element;
	private title: Element;
	private currentMonth: Date;
	private spinner: Element;
	private details: Element;

	constructor(private datasource: CalendarDatasource, targetId: string, private showSpinner = false) {
		const targetElement = document.getElementById(targetId);

		if(targetElement == null) {
			throw "Target not found";
		}

		this.target = targetElement;

		this.target.addEventListener('click', (event: MouseEvent) => this.onclick(event));

		this.renderBase();
		datasource.calendarRendered();


		this.updateDisplay(this.datasource.getFirstDate());

		datasource.reload = () => this.updateDisplay(this.currentMonth);
	}

	private onclick(eventArgs: MouseEvent) {
		const target = eventArgs.target as HTMLElement;

		if(target.classList.contains("_day")) {
			this.onDayClick(target);
		}
		else if (target.classList.contains("_active")) {
			if(target.classList.contains("_prev")) {
				this.onPrevClick();
			}
			else if(target.classList.contains("_next")) {
				this.onNextCLick();
			}
		}

		eventArgs.stopPropagation();
	}

	private onPrevClick() {
		const prevMonth = new Date(this.currentMonth.getTime());
		prevMonth.setUTCMonth(prevMonth.getUTCMonth() - 1);
		this.updateDisplay(prevMonth);
		this.datasource.onSelectMonth(this.currentMonth.getUTCFullYear(), this.currentMonth.getUTCMonth() + 1);
	}

	private onNextCLick() {
		const nextMonth = new Date(this.currentMonth.getTime());
		nextMonth.setUTCMonth(nextMonth.getUTCMonth() + 1);
		this.updateDisplay(nextMonth);
		this.datasource.onSelectMonth(this.currentMonth.getUTCFullYear(), this.currentMonth.getUTCMonth() + 1);
	}

	private clearSelection() {
		const currentSelected = this.target.getElementsByClassName("_selected");

		for(const selectedEntry of currentSelected) {
			selectedEntry.classList.remove("_selected");
		}

		if(this.details) {
			this.details.innerHTML = "";
		}
	}

	private onDayClick(target: HTMLElement) {

		this.clearSelection();

		target.classList.add("_selected");

		const key = target.getAttribute("data-date");

		if(key == null) {
			return;
		}

		if(this.datasource.shouldRenderDetails) {
			if(key != null) {
				this.updateDetails(key);
			}
		}

		this.datasource.onDateClick(key);
	}

	private renderBase() {
		let weekdaysHtml = "";
		for(let i = 0; i < Utility.weekdays.length; ++i) {
			weekdaysHtml += `<div class='_weekday _weekday_${i}'>${Utility.weekdays[i]}</div>`;
		}

		let template = `<div class='_prev icon-arrow-1-left'></div><div class='_next icon-arrow-1-right'></div><div class='_title headline4'></div><div class='_weekdays link2'>${weekdaysHtml}</div>`;

		for(let i = 0; i < 6; ++i) {

			let rowTemplate = '';

			for(let d = 0; d < 7; ++d) {
				const dayNum = i * 7 + d;
				rowTemplate += `<div class='_day _day_${dayNum}'></div>`;
			}

			template += `<div class='_row _row_${i} link2'>${rowTemplate}</div>`;
		}

		if(this.showSpinner) {
			template += "<div class='_spinnerContainer'><div class='spinner'></div></div>"
		}

		if(this.datasource.shouldRenderDetails) {
			template += "<div class='_details'></div>"
		}

		this.target.innerHTML = template;

		this.previous = this.target.getElementsByClassName("_prev")[0];
		this.next = this.target.getElementsByClassName("_next")[0];
		this.title = this.target.getElementsByClassName("_title")[0];

		if(this.showSpinner) {
			this.spinner = this.target.getElementsByClassName("_spinnerContainer")[0];
		}

		if(this.datasource.shouldRenderDetails) {
			this.details = this.target.getElementsByClassName("_details")[0];
		}
	}

	private updateDetails(dateKey: string) {
		const entries = this.datasource.getEventDetails(dateKey);
		let html = "";
		if(entries.length == 0){
			html= "<div class='_detail'>Keine Vorstellungen an diesem Tag</div>";
		}
		else{
			for(const entry of entries) {
				// TODO: change event rendering when it's clear under which conditions from fields "ticketsAvailableFrom" and "privateEvent" what should displayed
				const begin = moment(entry.begin).toDate();
				const now = new Date();
				let ticketUrl = "";
				let greenBadges = "";
				const nintyMinutes = new Date(now.getTime() + (90 * 60 * 1000));

				if(entry.price == null) {
					entry.price = ""
				}
				if(entry.dispoComment == null) {
					entry.dispoComment = ""
				}
				if(entry.type == null) {
					entry.type = ""
				}

				if(entry.cancelled === "1") {
					ticketUrl = "<a title='Abgesagt' class='icon-ticket _soldOut'></a>"
					greenBadges = '<span class="_green-badges"><span class="_text">abgesagt</span></span>';
				} else {
					if(entry.type === this.lastPlayType) {
						greenBadges = '<span class="_green-badges"><span class="_text">Zum<br>letzten<br>Mal</span></span>';
					}

					if (entry.price.toLowerCase().indexOf("eintritt frei") !== -1) {
						ticketUrl = "<a title='Freier Eintritt' class='icon-ticket _soldOut'></a>"
					} else if (entry.price.toLowerCase().indexOf("geschlossene vorstellung") !== -1) {
						ticketUrl = "<a title='Geschlossene Vorstellung' class='icon-ticket _soldOut'></a>"
					} else if(entry.ticketLink && begin >= nintyMinutes){
						ticketUrl = `<a title='Tickets kaufen' class='_ticket icon-ticket' target='_blank' href='${entry.ticketLink}' target='_blank'></a>`
					}else{
						ticketUrl = "<a title='Wenige Restkarten an der Abendkasse' class='icon-ticket _soldOut'></a>"
					}
				}

				let end = null;
				let timeString;
					if(entry.end != null) {
					end = moment(entry.end).toDate();
					timeString = `${Utility.getTime(begin)} - ${Utility.getTime(end)}`;
				}
				else {
					timeString = Utility.getTime(begin);
				}

				let icalUrl = "";
				if ((end == null && begin >= now) || (end != null && end >= now)) {
					let icalGet = "?date=";
					let tempDate = `${Utility.padNumber2(begin.getMonth() + 1)}/${Utility.padNumber2(begin.getDate())}/${begin.getFullYear()}`;
					icalGet += encodeURIComponent(tempDate);
					icalGet += `&sh=${Utility.padNumber2(begin.getHours())}&sm=${Utility.padNumber2(begin.getMinutes())}`;
					if (end != null) {
						icalGet += `&eh=${Utility.padNumber2(end.getHours())}&em=${Utility.padNumber2(end.getMinutes())}`;
					}
					icalGet += `&subject=${encodeURIComponent(entry.name)}`;

					icalUrl = `<a title='Kalenderdatei laden' aria-label='Kalenderdatei laden' class='_ical icon-calendar-mini' onClick='THOR.Main.logEvent({"produktionsId" : ${entry.ProduktionsId}, "vorstellungsId" : ${entry.id}, "type": "INTEREST"}, "30", function(){window.location.href="/ical/date${icalGet}"}); 'target: "blank"></a>`
				}

				var seperator1=""
				if(entry['place'] && entry['begin']){
					seperator1 = "<span class='seperator'></span>";
				}
				var seperator2=""
				if(entry['begin'] && entry['dispoComment']){
					seperator2 = "<span class='seperator'></span>";
				}

				var typePhone='';
				html += `
<div class='_detail'>
	<div class='_placeAndTime calendarMiniBold'><span class='_place'>${entry.place}</span>${seperator1} <span class='_time'>${timeString}</span>${seperator2} <span class='_dispoComment'>${entry.dispoComment}</span></div>
	<div class='_price calendarMini'>${entry.price}</div>

	<div class='_line3 calendarMiniBold'>`;
				switch (entry['type']) {
					case "Vorstellung":
					case "Voraufführung":
					case "Voraufführung öffentlich":
					case "Einzelvorstellung":
					case "Abstecher Gastspiel":
					case "Vermietung":
					case "Vermietung (Schauspielhaus Graz)":
					case "Pressekonferenz":
					case "Lesung":
					case "Ausstellung":
						if(entry.overTitle) {
							html += `<span class='_overtitle'>${entry.overTitle}</span>`;
						}
					break;
					case "Premiere":
					case "Zu Gast":
					case "Gastspiel":
					if(entry.type != null) {
						html += `<span class='_typeMobile'>${entry.type}</span>`;
					}

					if ((entry['overTitle'])) {
						html += `<span class='seperator'></span>
						<span class='_overtitle'>${entry.overTitle}</span>`;
					}
					break;
					case this.lastPlayType:
						if ((entry.overTitle)) {
							html += `<span class='_overtitle'>${entry.overTitle}</span>`;
						}
						break;
					case "Wiederaufnahme":
					if(entry.type != null) {
						html += `<span class='_type _warning'>${entry.type}</span>`;
					}

					if ((entry.overTitle)) {
						html += `<span class='_overtitle'> | ${entry.overTitle}</span>`;
					}
					break;
					default:
						if(entry.type != null) {
							html += `<span class='_type'>${entry.type}</span>`;
						}

						if ((entry.overTitle)) {
							html += `<span class='_overtitle'> | ${entry.overTitle}</span>`;
						}
					break;
				}
				html += `</div>`;

				html += `
				<div class='_name headline4'><a href='/play-detail/${entry.link}'>${entry.name}</a></div>
					<div class='_links'>
						${greenBadges}${icalUrl}${ticketUrl}
					</div>`

				if(entry.subtitle !== null) {
					html += `<div class='_subtitle calendarMini'>${entry.subtitle}</div>`
				}
				if(entry.addition1 !== null) {
					html += `<div class='_addition1 calendarMini'>${entry.addition1}</div>`
				}
				if(entry.addition2 !== null) {
					html += `<div class='_addition2 calendarMiniBold'>${entry.addition2}</div>`
				}

				html += `</div>`

			}
		}
		this.details.innerHTML = html;
	}

	private async updateDisplay(displayDate: Date) {
		this.clearSelection();

		const todayLocal = new Date();
		const today = new Date(Date.UTC(todayLocal.getFullYear(), todayLocal.getMonth(), todayLocal.getDate()));

		const firstOfMonth = new Date(Date.UTC(displayDate.getFullYear(), displayDate.getMonth(), 1));
		this.currentMonth = firstOfMonth;

		this.startAsyncOperation();
		if(!await this.datasource.loadMonth(firstOfMonth.getUTCFullYear(), firstOfMonth.getUTCMonth() + 1)) {
			//TODO: What to do if calendar load errors
		}
		this.endAsyncOperation();

		const firstOfNextMonth = new Date(firstOfMonth.getTime());
		firstOfNextMonth.setUTCMonth(firstOfMonth.getUTCMonth() + 1);

		const lastOfPreviousMonth = new Date(firstOfMonth.getTime());
		lastOfPreviousMonth.setUTCDate(0);

		const displayMonth = displayDate.getUTCMonth();

		let firstDayOfWeek = (firstOfMonth.getUTCDay() + 6) % 7;

		let current = new Date(firstOfMonth.getTime());
		current.setUTCDate(1 - firstDayOfWeek);

		for(let i = 0; i < 6; ++i) {
			for(let d = 0; d < 7; ++d) {
				const dayNum = i * 7 + d;

				const cellList = this.target.getElementsByClassName(`_day_${dayNum}`);

				if(cellList.length != 1) {
					throw "Structure error";
				}

				const cell = cellList[0];

				cell.setAttribute("data-date", Utility.getDateUtcKey(current));

				cell.innerHTML = Utility.padNumber2(current.getDate());
				Utility.toggleClass(cell, '_hasEvent', this.datasource.hasEvent(current));
				Utility.toggleClass(cell, '_otherMonth', current.getUTCMonth() != displayMonth);
				Utility.toggleClass(cell, '_today', today.getTime() == current.getTime());

				current.setUTCDate(current.getUTCDate() + 1);
			}
		}

		Utility.toggleClass(this.previous, "_active", this.datasource.getFirstDate() <= lastOfPreviousMonth);
		Utility.toggleClass(this.next, "_active", this.datasource.getLastDate() >= firstOfNextMonth);

		this.title.innerHTML = `${Utility.months[displayMonth]} ${displayDate.getUTCFullYear()}`;

		if(this.datasource.shouldRenderDetails) {
			let todayForReload = new Date();
			this.updateDetails(todayForReload.getFullYear() + "-" + ('0' + (todayForReload.getMonth() + 1)).slice(-2) + "-" + ('0' + (todayForReload.getDate())).slice(-2));
		}
	}

	private startAsyncOperation() {
		if(this.spinner) {
			this.spinner.classList.add("_spinning");
		}
	}

	private endAsyncOperation() {
		if(this.spinner) {
			this.spinner.classList.remove("_spinning");
		}
	}
}
